import { InboxOutlined } from '@ant-design/icons'
import { Progress, Row } from 'antd'
import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
const Container = styled.div``
const SubContainer = styled.div``
const color = {
  no_procent: '#f5f5f5',
  percent_0: '#f5f5f5',
  percent_50: '#FF6258',
  percent_75: '#FFAF00',
  percent_100: '#19D895',
}
const initalState = {
  data: [],
  isLoading: true,
}

const Inprogress = (props) => {
  const { token, data_kos, word } = props
  const history = useHistory()
  const ContainerState = () => {
    if (data_kos.length > 0) {
      return (
        <SubContainer className="sub-container">
          {data_kos?.map((val) => (
            <div className="sub-container-inprogress">
              <div className="layout-detail">
                <p
                  className="text-name-project cutter-text-line-1"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    history.push({
                      pathname: `/project/${val.id}/edit`,
                    })
                  }}
                >
                  {val.name}
                </p>
                <Row className="progress-container">
                  <Progress
                    className="progress-bar"
                    percent={val.done_percent}
                    size="small"
                    strokeColor={
                      val.done_percent < 75 && val.done_percent !== 0
                        ? color.percent_50
                        : val.done_percent === 100
                        ? color.percent_100
                        : val.done_percent === 0
                        ? color.percent_0
                        : color.percent_75
                    }
                  />
                  <span
                    className={`small numberstyle ${
                      val.done_percent < 75 && val.done_percent !== 0
                        ? 'percent-deley'
                        : val.done_percent === 100
                        ? 'percent-done'
                        : val.done_percent === 0
                        ? 'percent-zero'
                        : 'percent-todo'
                    }`}
                  >
                    {val.done_percent} %
                  </span>
                </Row>
                <div className="text-date">
                  {word['kos_kickoff_date']} : {moment(val.kickoff).format('D MMM YYYY')}
                </div>
              </div>
            </div>
          ))}
        </SubContainer>
      )
    } else {
      return (
        <div className="emytystate edit-height-emptystate-summary">
          <InboxOutlined className="inbox" />
          <p>No Project in Progress</p>
        </div>
      )
    }
  }
  return (
    <Container>
      <h3>{word['kos_title']}</h3>
      {ContainerState()}
    </Container>
  )
}
export default Inprogress
